import { type FeatureFlagName } from "@inrev/common";
import { useFeatureFlags } from "@portal/api/feature-flags";

export const useFeatureFlag = (flag: FeatureFlagName) => {
	// Should be prefetched, so this should not trigger a loading state. If it does, we will treat the flag as disabled until the flags are loaded.
	const { featureFlags, featureFlagsLoading } = useFeatureFlags();

	// If feature flags fail to load, we want to treat the flag as disabled
	if (!featureFlags || featureFlagsLoading) {
		return false;
	}

	// If the flag is not found, we also want to treat the flag as disabled
	return featureFlags.find((f) => f.name === flag)?.enabled ?? false;
};
